"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require("./");
Object.defineProperty(Intl, 'PluralRules', {
    value: _1.PluralRules,
    writable: true,
    enumerable: false,
    configurable: true,
});
